// extracted by mini-css-extract-plugin
export default {"topNews":"index_topNews_P-ivg","first_title":"index_first_title_xVuvm","second_title":"index_second_title_sU7NW"};